import { use } from 'react';

import { MobileChromeContext, type MobileChromeContextValue } from './MobileChromeContext';

/** Reads the app shell's mobile-chrome flags. Inert (trigger visible) outside the provider. */
export function useMobileChrome(): MobileChromeContextValue {
    return use(MobileChromeContext);
}
